/* ============================================================
   NOVAA GEAR — support page behaviour
   · TOC / jump active-section highlight (scroll spy)
   · smooth jump-chip scrolling on mobile
   · guide grid filter chips
   · fake form submit (trade portal)
   No dependencies.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- scroll-spy for TOC + mobile jump chips ---------- */
  var sections = Array.prototype.slice.call(document.querySelectorAll('.doc-section[id]'));
  if (sections.length) {
    var links = {};
    document.querySelectorAll('.doc-toc a[href^="#"], .doc-jump a[href^="#"]').forEach(function (a) {
      var id = a.getAttribute('href').slice(1);
      (links[id] = links[id] || []).push(a);
    });

    var current = null;
    function setActive(id) {
      if (id === current) return;
      current = id;
      Object.keys(links).forEach(function (key) {
        links[key].forEach(function (a) { a.classList.toggle('is-active', key === id); });
      });
      // keep the active mobile chip in view
      var jump = document.querySelector('.doc-jump');
      if (jump && links[id]) {
        var chip = links[id].find(function (a) { return a.closest('.doc-jump'); });
        if (chip) {
          var cl = chip.offsetLeft, cw = chip.offsetWidth, sl = jump.scrollLeft, vw = jump.clientWidth;
          if (cl < sl || cl + cw > sl + vw) jump.scrollTo({ left: cl - 16, behavior: 'smooth' });
        }
      }
    }

    var io = new IntersectionObserver(function (entries) {
      // pick the entry nearest the top that is intersecting
      var visible = entries.filter(function (e) { return e.isIntersecting; });
      if (visible.length) {
        visible.sort(function (a, b) { return a.boundingClientRect.top - b.boundingClientRect.top; });
        setActive(visible[0].target.id);
      }
    }, { rootMargin: '-72px 0px -65% 0px', threshold: 0 });

    sections.forEach(function (s) { io.observe(s); });
    setActive(sections[0].id);
  }

  /* ---------- guide filter chips ---------- */
  var filterWrap = document.querySelector('[data-guide-filter]');
  if (filterWrap) {
    var cards = Array.prototype.slice.call(document.querySelectorAll('.dl-card[data-tags]'));
    filterWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-filter]');
      if (!btn) return;
      filterWrap.querySelectorAll('button').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      var f = btn.getAttribute('data-filter');
      cards.forEach(function (c) {
        var show = f === 'all' || (' ' + c.getAttribute('data-tags') + ' ').indexOf(' ' + f + ' ') > -1;
        c.style.display = show ? '' : 'none';
      });
    });
  }

  /* ---------- REMOVED 5 Aug 2026: the fake trade-application submit ----------
     This block bound to [data-fakeform], called preventDefault() and painted
     "Application sent ✓" on the button without sending anything anywhere. The
     trade form in sections/sup-trade.liquid is now a real Shopify contact form,
     so this handler is gone rather than left dormant. Do not reinstate it — a
     handler that fakes success is worse than no handler at all. */
})();
